<template>
  <div class="modal-body" :class="[width, { 'full-height': fullHeight }]">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NModalBody extends Vue {
  @Prop({ default: 'm' }) width!: 'xs' | 's' | 'm' | 'l'
  @Prop({ type: Boolean, default: false }) fullHeight!: boolean
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles' as *;

// Bottom sheet. `width: 100%` rather than 100vw: 100vw includes the scrollbar gutter, which made the
// sheet wider than its own layout box and pushed its right edge under the clip.
@mixin notch-modal-mobile-styles {
  width: 100%;
  margin: 0;
  position: absolute;
  inset: auto 0 0 0;
  padding: $notch-space-6x $notch-space-4x $notch-space-6x $notch-space-4x;

  // The desktop `height: calc(100dvh - 2 * margin)` below is compensation for a margin this mixin
  // has just removed. Left uncorrected it made a bottom-pinned sheet 80px short of the top of the
  // screen; combined with the centred (non-mobile) case above $phone it read as a blank strip under
  // the modal. A mobile sheet is simply the whole screen.
  &.full-height {
    height: 100dvh;
    border-radius: 0;
  }
}

.modal-body {
  border-radius: $notch-space-2x;
  background-color: white;
  margin: $notch-space-10x;
  @include notch-style-floating;

  // dvh, not vh: NBackdrop - the box this is positioned against - measures the *visible* viewport,
  // so anything measuring the large (URL-bar-retracted) viewport here disagrees with it about where
  // the bottom of the screen is.
  &.full-height {
    height: calc(100dvh - 2 * $notch-space-10x);
    max-height: 100%;
  }

  &.xxs {
    width: $notch-space-107_5x;

    @include mobile {
      @include notch-modal-mobile-styles;
    }
  }

  &.xs {
    width: $notch-space-120x;

    @include mobile {
      @include notch-modal-mobile-styles;
    }
  }

  &.s {
    width: $notch-space-156x;

    @include mobile {
      @include notch-modal-mobile-styles;
    }
  }

  &.m {
    width: $notch-space-218x;

    @include mobile {
      @include notch-modal-mobile-styles;
    }
  }

  &.l {
    width: $notch-space-297x;

    @include mobile {
      @include notch-modal-mobile-styles;
    }
  }
}
</style>
